import { Popover } from '@mui/material'
import React from'react'
export const TooltipPopover=({anchorEl,handleClose,desc})=>{
    const open = Boolean(anchorEl,handleClose);
    const id = open ? "popover-dropdown" : undefined;


return(
          <Popover
            id={id}
            // sx={{width:'350px'}}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
    
          >
            <div className ="regular-bold"style={{ padding: '10px',width:'230px' }}>
            {desc}
            </div>
          </Popover>
)
}